import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box, Container, Typography, Grid } from '@material-ui/core';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles = makeStyles(function (theme) {
  return {
    responsiveImage: {
      width: "100%",
      maxWidth: theme.spacing(21.5)
    }
  };
});
var TilesImages = function TilesImages(_ref) {
  var title = _ref.title,
    tiles = _ref.tiles,
    gridColumns = _ref.gridColumns,
    gridSpacing = _ref.gridSpacing,
    backgroundColor = _ref.backgroundColor,
    titleStyle = _ref.titleStyle;
  var classes = useStyles();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    images = _useState2[0],
    setImages = _useState2[1];
  useEffect(function () {
    if (tiles && classes) {
      var items = [];
      var _iterator = _createForOfIteratorHelper(tiles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _tile$image, _tile$image2;
          var tile = _step.value;
          items.push({
            url: tile === null || tile === void 0 || (_tile$image = tile.image) === null || _tile$image === void 0 ? void 0 : _tile$image.url,
            title: tile === null || tile === void 0 || (_tile$image2 = tile.image) === null || _tile$image2 === void 0 ? void 0 : _tile$image2.title
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      setImages(items);
    }
  }, [tiles, classes]);
  return /*#__PURE__*/React__default.createElement(Box, {
    py: 10,
    textAlign: "center",
    style: {
      background: backgroundColor ? backgroundColor : "#FFFFFF"
    }
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, title && /*#__PURE__*/React__default.createElement(Box, {
    mb: 7,
    textAlign: titleStyle !== null && titleStyle !== void 0 && titleStyle.textAlignment ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.textAlignment.toLowerCase() : "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle !== null && titleStyle !== void 0 && titleStyle.headingVariant ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingVariant : "h1",
    component: "h2"
  }, title)), (images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: "center",
    spacing: isNaN(gridSpacing) ? 2 : gridSpacing
  }, images === null || images === void 0 ? void 0 : images.map(function (image, index) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      sm: gridColumns ? 12 / gridColumns : "auto",
      key: index
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.responsiveImage,
      alt: image.title || "",
      src: retrieveContentfulImage(image === null || image === void 0 ? void 0 : image.url, {
        width: 172
      })
    }));
  }))));
};
TilesImages.propTypes = {
  title: PropTypes__default.string,
  tiles: PropTypes__default.arrayOf(PropTypes__default.shape({
    image: PropTypes__default.shape({
      url: PropTypes__default.string,
      title: PropTypes__default.string
    })
  })),
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  gridSpacing: PropTypes__default.number,
  backgroundColor: PropTypes__default.string,
  titleStyle: PropTypes__default.shape({
    textAlignment: PropTypes__default.string,
    headingVariant: PropTypes__default.string,
    headingStyle: PropTypes__default.string
  })
};

export { TilesImages as default };
//# sourceMappingURL=TilesImages.js.map
